<script setup>
import FeedbackMessage from "@/Components/forms/FeedbackMessage.vue";
import { fieldHasError } from "@/lib/utils.js";
import { computed } from "vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  class: { type: null, required: false },
  errorMessage: {
    type: String,
    required: true,
    default: "This field is required",
  },
  errors: {
    type: Object,
    required: true,
  },
  field: {
    type: String,
    required: true,
  },
});

const formattedLabel = computed(() => {
  return props.label.replace(
    /\*/g,
    '<span class="text-red-600 font-black" style="-webkit-text-stroke: 0.5px red; font-size: 1.1em;">*</span>',
  );
});
</script>

<template>
  <div class="w-full flex flex-col" :class="props.class">
    <div
      class="flex items-center space-x-5 uppercase text-sm border-b border-b-brand-dark-blue pt-[0.9rem] mt-auto min-h-[3.2rem]"
    >
      <div
        class="mt-[-0.8rem] leading-none pl-1 lg:whitespace-nowrap"
        v-html="formattedLabel"
      ></div>
      <div class="w-full flex flex-wrap">
        <slot />
      </div>
    </div>
    <FeedbackMessage
      v-if="fieldHasError(errors, field)"
      :message="errorMessage"
      :error="true"
    />
  </div>
</template>

<style scoped></style>
